import React from 'react';
import pt from 'prop-types';
import Button from "@material-ui/core/Button";

const PrimaryButton = ({href, children, ...rest}) => {
    return (
        <Button variant="contained" color="primary" href={href} type="submit" {...rest}>
            {children}
        </Button>
    );
};

PrimaryButton.propTypes = {
    href: pt.string,
    children: pt.node
};

export default PrimaryButton;
